import React from "react";
import styled from "styled-components";
import { ReactComponent as CaseFilledIcon } from "./briefcase-filled.svg";
import { ReactComponent as CompanyFilledIcon } from "./building-filled.svg";
import { ReactComponent as CompanyIcon } from "./building.svg";
import { ReactComponent as DeleteIcon } from "./delete.svg";
import { ReactComponent as DocCheckFilledIcon } from "./doc-checkmark-filled.svg";
import { ReactComponent as DocErrorFilledIcon } from "./doc-error-filled.svg";
import { ReactComponent as DocWarnFilledIcon } from "./doc-warn-filled.svg";
import { ReactComponent as DocFilledIcon } from "./document-filled.svg";
import { ReactComponent as EditIcon } from "./edit.svg";
import { ReactComponent as ExitFilledIcon } from "./exit-filled.svg";
import { ReactComponent as ExitIcon } from "./exit.svg";
import { ReactComponent as EyeIcon } from "./eye.svg";
import { ReactComponent as EyeHideIcon } from "./eye-hide.svg";
import { ReactComponent as EyeShowIcon } from "./eye-show.svg";
import { ReactComponent as GearFilledIcon } from "./gear-filled.svg";
import { ReactComponent as GearIcon } from "./gear.svg";
import { ReactComponent as LockIcon } from "./lock.svg";
import { ReactComponent as MailFilledIcon } from "./mail-filled.svg";
import { ReactComponent as MailIcon } from "./mail.svg";
import { ReactComponent as PhoneFilledIcon } from "./phone-filled.svg";
import { ReactComponent as PhoneIcon } from "./phone.svg";
import { ReactComponent as PlusIcon } from "./plus.svg";
import { ReactComponent as PlusBlackIcon } from "./plus-black.svg";
import { ReactComponent as MinusIcon } from "./minus.svg";
import { ReactComponent as SearchFilledIcon } from "./search-filled.svg";
import { ReactComponent as SearchIcon } from "./search.svg";
import { ReactComponent as UserFilledIcon } from "./user-filled.svg";
import { ReactComponent as UserIcon } from "./user.svg";
import { ReactComponent as ArrowLeftIcon } from "./arrow-left.svg";
import { ReactComponent as MobileMenuIcon } from "./mobile-menu.svg";
import { ReactComponent as IdIcon } from "./id.svg";
import { ReactComponent as IdIconFilled } from "./id-filled.svg";
import { ReactComponent as CaseIcon } from "./briefcase.svg";
import { ReactComponent as LogoIcon } from "./logo.svg";
import { ReactComponent as CalendarIcon } from "./calendar.svg";
import { ReactComponent as CalendarFilledIcon } from "./calendar-filled.svg";
import { ReactComponent as CalendarCheckIcon } from "./calendar-check.svg";
import { ReactComponent as CalendarCheckFilledIcon } from "./calendar-check-filled.svg";
import { ReactComponent as CalendarXIcon } from "./calendar-x.svg";
import { ReactComponent as CalendarXFilledIcon } from "./calendar-x-filled.svg";
import { ReactComponent as DocumentIcon } from "./document.svg";
import { ReactComponent as CalculatorIcon } from "./calculator.svg";
import { ReactComponent as CircleCheckIcon } from "./circle-check.svg";
import { ReactComponent as CircleXIcon } from "./circle-x.svg";
import { ReactComponent as CircleCheckFilledIcon } from "./circle-check-filled.svg";
import { ReactComponent as CircleXFilledIcon } from "./circle-x-filled.svg";
import { ReactComponent as SendIcon } from "./send.svg";

interface IconProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
  color?: string;
}

const Svg = styled.svg<IconProps>`
  width: ${({ size }) => size || 24}px;
  height: ${({ size }) => size || 24}px;
  color: ${({ color, theme }) => color || theme.colors.text};
  transition: color 0.2s;
`;

export const IconCaseFilled: React.FC<IconProps> = (props) => (
  <Svg as={CaseFilledIcon} {...props} />
);

export const IconCompanyFilled: React.FC<IconProps> = (props) => (
  <Svg as={CompanyFilledIcon} {...props} />
);

export const IconCompany: React.FC<IconProps> = (props) => (
  <Svg as={CompanyIcon} {...props} />
);

export const IconDelete: React.FC<IconProps> = (props) => (
  <Svg as={DeleteIcon} {...props} />
);

export const IconDocCheckFilled: React.FC<IconProps> = (props) => (
  <Svg as={DocCheckFilledIcon} {...props} />
);

export const IconDocErrorFilled: React.FC<IconProps> = (props) => (
  <Svg as={DocErrorFilledIcon} {...props} />
);

export const IconDocWarnFilled: React.FC<IconProps> = (props) => (
  <Svg as={DocWarnFilledIcon} {...props} />
);

export const IconDocFilled: React.FC<IconProps> = (props) => (
  <Svg as={DocFilledIcon} {...props} />
);

export const IconEdit: React.FC<IconProps> = (props) => (
  <Svg as={EditIcon} {...props} />
);

export const IconExitFilled: React.FC<IconProps> = (props) => (
  <Svg as={ExitFilledIcon} {...props} />
);

export const IconExit: React.FC<IconProps> = (props) => (
  <Svg as={ExitIcon} {...props} />
);

export const IconEye: React.FC<IconProps> = (props) => (
  <Svg as={EyeIcon} {...props} />
);

export const IconEyeHide: React.FC<IconProps> = (props) => (
  <Svg as={EyeHideIcon} {...props} />
);

export const IconEyeShow: React.FC<IconProps> = (props) => (
  <Svg as={EyeShowIcon} {...props} />
);

export const IconGearFilled: React.FC<IconProps> = (props) => (
  <Svg as={GearFilledIcon} {...props} />
);

export const IconGear: React.FC<IconProps> = (props) => (
  <Svg as={GearIcon} {...props} />
);

export const IconLock: React.FC<IconProps> = (props) => (
  <Svg as={LockIcon} {...props} />
);

export const IconMailFilled: React.FC<IconProps> = (props) => (
  <Svg as={MailFilledIcon} {...props} />
);

export const IconMail: React.FC<IconProps> = (props) => (
  <Svg as={MailIcon} {...props} />
);

export const IconPhoneFilled: React.FC<IconProps> = (props) => (
  <Svg as={PhoneFilledIcon} {...props} />
);

export const IconPhone: React.FC<IconProps> = (props) => (
  <Svg as={PhoneIcon} {...props} />
);

export const IconPlus: React.FC<IconProps> = (props) => (
  <Svg as={PlusIcon} {...props} />
);

export const IconPlusBlack: React.FC<IconProps> = (props) => (
  <Svg as={PlusBlackIcon} {...props} />
);

export const IconMinus: React.FC<IconProps> = (props) => (
  <Svg as={MinusIcon} {...props} />
);

export const IconSearchFilled: React.FC<IconProps> = (props) => (
  <Svg as={SearchFilledIcon} {...props} />
);

export const IconSearch: React.FC<IconProps> = (props) => (
  <Svg as={SearchIcon} {...props} />
);

export const IconUserFilled: React.FC<IconProps> = (props) => (
  <Svg as={UserFilledIcon} {...props} />
);

export const IconUser: React.FC<IconProps> = (props) => (
  <Svg as={UserIcon} {...props} />
);

export const IconArrowLeft: React.FC<IconProps> = (props) => (
  <Svg as={ArrowLeftIcon} {...props} />
);

export const IconMobileMenu: React.FC<IconProps> = (props) => (
  <Svg as={MobileMenuIcon} {...props} />
);

export const IconId: React.FC<IconProps> = (props) => (
  <Svg as={IdIcon} {...props} />
);

export const IconIdFilled: React.FC<IconProps> = (props) => (
  <Svg as={IdIconFilled} {...props} />
);

export const IconCase: React.FC<IconProps> = (props) => (
  <Svg as={CaseIcon} {...props} />
);

export const Logo: React.FC<IconProps> = (props) => (
  <Svg as={LogoIcon} {...props} />
);

export const IconCalendar: React.FC<IconProps> = (props) => (
  <Svg as={CalendarIcon} {...props} />
);

export const IconCalendarFilled: React.FC<IconProps> = (props) => (
  <Svg as={CalendarFilledIcon} {...props} />
);

export const IconCalendarCheck: React.FC<IconProps> = (props) => (
  <Svg as={CalendarCheckIcon} {...props} />
);

export const IconCalendarCheckFilled: React.FC<IconProps> = (props) => (
  <Svg as={CalendarCheckFilledIcon} {...props} />
);

export const IconCalendarX: React.FC<IconProps> = (props) => (
  <Svg as={CalendarXIcon} {...props} />
);

export const IconCalendarXFilled: React.FC<IconProps> = (props) => (
  <Svg as={CalendarXFilledIcon} {...props} />
);

export const IconDocument: React.FC<IconProps> = (props) => (
  <Svg as={DocumentIcon} {...props} />
);

export const IconCalculator: React.FC<IconProps> = (props) => (
  <Svg as={CalculatorIcon} {...props} />
);

export const IconCircleCheck: React.FC<IconProps> = (props) => (
  <Svg as={CircleCheckIcon} {...props} />
);

export const IconCircleX: React.FC<IconProps> = (props) => (
  <Svg as={CircleXIcon} {...props} />
);

export const IconCircleCheckFilled: React.FC<IconProps> = (props) => (
  <Svg as={CircleCheckFilledIcon} {...props} />
);

export const IconCircleXFilled: React.FC<IconProps> = (props) => (
  <Svg as={CircleXFilledIcon} {...props} />
);

export const IconSend: React.FC<IconProps> = (props) => (
  <Svg as={SendIcon} {...props} />
);
